/**
 * axios setup
 */

import axios, { AxiosRequestConfig } from 'axios';

const axiosServices = axios.create({ baseURL: import.meta.env.VITE_API_BASE_URL || 'http://localhost:3010/' });

// Note: Authentication interceptors are configured in src/auth/infrastructure/AxiosAuthInterceptor.ts

export default axiosServices;

export const fetcher = async (args: string | [string, AxiosRequestConfig]) => {
  const [url, config] = Array.isArray(args) ? args : [args];

  const res = await axiosServices.get(url, { ...config });

  return res.data;
};
